import React from 'react'
import icon1 from "./images/icon1.png"
import icon2 from "./images/icon2.png"
import icon3 from "./images/icon3.png"
import icon4 from "./images/icon4.png"
import { useTranslation } from "react-i18next";
import "./style.css"


const Services = () => {
    const { t } = useTranslation();
  return (
    <section id="Services">
       <div className="servicesBlock">
            <div className="info">
                <h1> {t("services.title")} </h1>
                <p>
                    {t("services.description")}
                </p>
            </div>

            <div className="serviceCards">
                <div className="cards div1">
                    <div className='cardText'>
                        <p>
                            {t("services.service1")} <span></span> 
                        </p>
                        <p>
                            {t("services.service2")} <span></span> 
                        </p>
                        <p>
                            {t("services.service3")} <span></span> 
                        </p>
                        <p>
                            {t("services.service4")} <span></span> 
                        </p>
                    </div>
                    <div className='cardIcon'>
                        <img src={icon1}/>
                    </div>
                </div>
                <div className="cards div2">
                    <div className='cardIcon'>
                        <img src={icon2}/>
                    </div>
                    <div className='cardText'>
                        <p>
                            <span></span> {t("services.service5")}
                        </p>
                        <p>
                            <span></span> {t("services.service6")}
                        </p>
                        <p>
                            <span></span> {t("services.service7")}
                        </p>
                        <p>
                            <span></span> {t("services.service8")}
                        </p>
                    </div>
                </div>
                <div className="cards div3">
                    <div className='cardText'>
                        <p>
                             {t("services.service9")} <span></span>
                        </p>
                    </div>
                    <div className='cardIcon'>
                        <img src={icon3}/>
                    </div>
                </div>
                <div className="cards div4">
                    <div className='cardIcon'>
                        <img src={icon4}/>
                    </div>
                    <div className='cardText'>
                        <p>
                           <span></span> {t("services.service10")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
export default Services;